// Authentication Constants
import { v4 as uuidv4 } from "uuid";

// Error codes
export const ERROR_CODES = {
  NO_ASAN_TOKEN: 1306,
  TOKEN_EXPIRED: 1702,
};

// Timer constants
// ASAN docs require: wait 10-15s before first poll, then poll every 2-10s
export const TIMER_CONSTANTS = {
  INITIAL_SECONDS: 120,
  CHECK_INTERVAL_MS: 1000,
  INITIAL_POLL_DELAY_SECONDS: 10,  // wait 10s before first status check
  STATUS_CHECK_INTERVAL: 5,        // then check every 5s thereafter
};

/**
 * Builds ASAN authorization URL based on environment
 * @returns {string} ASAN authorization URL
 */
export const buildAsanAuthorizationUrl = () => {
  const env = process.env.REACT_APP_ENV;
  
  let baseUrl, clientId, redirectUri;
  
  if (env === "test") {
    baseUrl = process.env.REACT_APP_DIGITAL_LOGIN_TEST_URL;
    clientId = process.env.REACT_APP_DIGITAL_LOGIN_TEST_CLIENT_ID;
    redirectUri = process.env.REACT_APP_CABINET_TEST_URL;
  } else if (env === "production") {
    baseUrl = process.env.REACT_APP_DIGITAL_LOGIN_URL;
    clientId = process.env.REACT_APP_DIGITAL_LOGIN_CLIENT_ID;
    redirectUri = process.env.REACT_APP_CABINET_URL;
  } else {
    // Default fallback
    baseUrl = process.env.REACT_APP_DIGITAL_LOGIN_URL;
    clientId = process.env.REACT_APP_DIGITAL_LOGIN_CLIENT_ID;
    redirectUri = process.env.REACT_APP_CABINET_URL;
  }
  
  const state = uuidv4();
  // Store state so we can verify it on the OAuth callback to prevent CSRF
  sessionStorage.setItem("oauthState", state);
  const scope = "openid certificate session";

  return `${baseUrl}/grant-permission?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&state=${state}&scope=${scope}`;
};
